/*
 * @Author: LQ
 * @Date: 2022-08-01 11:17:19
 * @LastEditors: Jss
 * @LastEditTime: 2024-06-21 14:15:12
 * @FilePath: \scm-pc\src\config\provide.js
 * @Description: 提供全局的provide key
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */
// 大屏页面数据
export const BS_PAGE_KEY = Symbol('big-screen-page-key');

// 大屏初始化参数
export const BS_INITIAL_PARAMS_KEY = Symbol('big-screen-initial-params');

export const MIX_OUTPUT_DATA_KEY = Symbol('mix-output-data');

export const FROM_KEY = Symbol('from-key');

// 大屏容器参数
export const BS_LAYOUT_SIZE_KEY = Symbol('big-screen-layout-size');

// 判断是否在大屏容器中
export const BS_IS_IN_BS = Symbol('big-screen-is-in-big-screen');

// 判断是否在弹窗中
export const RENDER_IS_IN_MODAL = Symbol('render-is-in-modal');
export const RENDER_IS_IN_DIALOG = Symbol('render-is-in-dialog');
export const RENDER_TYPE = Symbol('render-type');
export const RENDER_ROUTE_DATA = Symbol('render-route-data');

export const OFFICIAL_VERSION_KEY = Symbol('OFFICIAL_VERSION');

export const APP_ELEMENT_KEY = Symbol('APP_ELEMENT_KEY');

export const PAGE_BUILDER_OBJ_KEY = Symbol('PAGE_BUILDER_OBJ_KEY');

// 判断是否重新加载富文本数据
export const REFRESH_RICH_TEXT = Symbol('refresh_rich_text');

export const PAGE_ID_KEY = Symbol('PAGE_ID_KEY');

export const PAGE_OBJ_KEY = Symbol('PAGE_OBJ_KEY');

// 判断是否在表单中
export const RENDER_IS_IN_FORM = Symbol('render-is-in-form');

// 判断是否在弹窗中 FixedDialog (只渲染组件)

export const RENDER_IS_IN_FIXED_DIALOG = Symbol('render-is-in-fixed-dialog');
